import React from 'react';
import './logo.scss';

const Logo = ({options}) => {
  options = (options)?options:"";
  return (
    <div className={"logo-c "+options}>
      <span className="dawipay">Swiperino</span>
      <span className="admin">Admin</span>
    </div>
  );

};

export default Logo;